import Swiper from "swiper";
import { Navigation, Pagination, Thumbs, FreeMode } from "swiper/modules";

const initialize = () => {
  const thumbSwiper = new Swiper(".gd-product-images .gd-thumb-swiper", {
    modules: [FreeMode, Thumbs],
    spaceBetween: 16,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
  });
  const swiper = new Swiper(".gd-product-images .gd-swiper", {
    modules: [Navigation, Pagination, Thumbs],
    // loop: true,
    navigation: {
      nextEl: ".gd-product-images .gd-swiper .swiper-button-next",
      prevEl: ".gd-product-images .gd-swiper .swiper-button-prev",
    },
    pagination: {
      el: ".gd-product-images .gd-swiper .swiper-pagination",
      clickable: true,
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (window.kochibin.template != "product") {
    return;
  }
  initialize();
});
